// src/presentation/pages/ClinicalExamination/sections/PerceptionSleepSection.tsx
import React from "react";
import { CardTitle } from "@/components/ui/card";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";
import { booleanRadioValue } from "../types";

interface PerceptionSleepSectionProps {
  visualHallucinations: boolean | null;
  actingOutDreams: boolean | null;
  onVisualHallucinationsChange: (value: boolean) => void;
  onActingOutDreamsChange: (value: boolean) => void;
}

export const PerceptionSleepSection: React.FC<PerceptionSleepSectionProps> = ({
  visualHallucinations,
  actingOutDreams,
  onVisualHallucinationsChange,
  onActingOutDreamsChange,
}) => {
  const { t } = useTranslation("patients");
  return (
    <div className=" border-gray-200">
      <div className="pb-3">
        <CardTitle className="text-base font-semibold text-gray-900">
          {t("clinicalSections.perceptionSleep.title")}
        </CardTitle>
      </div>
      <div className="space-y-6">
        {/* Visual Hallucinations */}
        <div>
          <p className="text-sm text-gray-700 mb-3">
            {t("clinicalSections.perceptionSleep.hallucinationsQuestion")}
          </p>
          <RadioGroup
            value={booleanRadioValue(visualHallucinations)}
            onValueChange={(val) =>
              onVisualHallucinationsChange(val === "true")
            }
            className="flex gap-6"
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="true" id="hallucinations-yes" />
              <Label
                htmlFor="hallucinations-yes"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.yes")}
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="false" id="hallucinations-no" />
              <Label
                htmlFor="hallucinations-no"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.no")}
              </Label>
            </div>
          </RadioGroup>
        </div>

        {/* Acting Out Dreams */}
        <div>
          <p className="text-sm text-gray-700 mb-3">
            {t("clinicalSections.perceptionSleep.actingOutDreamsQuestion")}
          </p>
          <RadioGroup
            value={booleanRadioValue(actingOutDreams)}
            onValueChange={(val) => onActingOutDreamsChange(val === "true")}
            className="flex gap-6"
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="true" id="dreams-yes" />
              <Label
                htmlFor="dreams-yes"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.yes")}
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="false" id="dreams-no" />
              <Label
                htmlFor="dreams-no"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.no")}
              </Label>
            </div>
          </RadioGroup>
        </div>
      </div>
    </div>
  );
};
